import { useState } from "react";
import { ModalPage } from "../constants/cash-status";
import { createContainer } from "unstated-next";

export function useLotteryStoreHook() {
  const [currentModalPage, setCurrentModalPage] = useState(
    ModalPage.PrizeCouponPage
  );
  const [currentActivityID, setCurrentActivityID] = useState(0);
  return {
    currentModalPage,
    setCurrentModalPage,
    currentActivityID,
    setCurrentActivityID,
  };
}

const LotteryStoreContainer = createContainer(useLotteryStoreHook);

export const LotteryStoreContainerProvider = LotteryStoreContainer.Provider;

export function useLotteryStore() {
  return LotteryStoreContainer.useContainer();
}
